export const LDAP_CONNECTION_REST_ENDPOINT = 'api/v1/ldap-connections';

export const MAX_DIRECTORIES = 10;

export const MASKED_PASSWORD_PLACEHOLDER = '************';

export const ACTIVE_DIRECTORY_INTERVALS: Record<string, string> = {
    minutes5: '0 */5 * * * *',
    minutes10: '0 */10 * * * *',
    daily: '0 0 5 * * *',
    daily2: '0 0 21 * * *',
    weekly: '0 0 5 * * 6',
    weekly2: '0 0 21 * * 6',
};

export const MAX_AD_FIELD_LENGTH = 48;
